<template>
    <div class="parallax  " :class="{'shadowed':b.box_shadow}">
        <div class="para" :style="{backgroundImage:`url(${b.bild.url})`}"></div>
        <!--            <img :src="b.bild.url" alt="">-->
    </div>
</template>
<script>
    import jQuery from "jquery";
    export default {
        name: "Parallax",
        props: {b: Object},
        data() {
            return {
                position: Array
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
            // let shape = this.getRelativePosition()
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            handleScroll() {
                const shape = this.$el.getBoundingClientRect();
                const $pic = jQuery(this.$el.querySelector('.para'))
                let winheight = window.innerHeight
                let height = shape.bottom - shape.top
                let x = (shape.bottom) / (winheight + height) * 100
                jQuery($pic).css('background-position', '0 ' + x + '%')
                return {
                    top: shape.top,
                    left: shape.left,
                };
            },
        }
    }
</script>
<style scoped lang="scss">
    .parallax {
        height: 600px;
        @include mobile {
            height: 300px;
        }
        width: 100%;
        .para {
            height: 100%;
            background-size: cover;
            /*perspective: 1000px;*/
            /*background-position-y: 100%;*/
            /*transition: background-position 0.1s ease;*/
        }
    }
</style>